interface LogoutbtnProps {
  className?: string;
}

const Logoutbtn = (props: LogoutbtnProps) => {
  return (
    <svg
      className={`${props.className ? props.className : ""}`}
      width="34"
      height="33"
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 16.6667C3.5 12.4602 4.99604 9.19822 7.32766 6.98338C9.67117 4.75725 12.9538 3.5 16.6667 3.5C17.4951 3.5 18.1667 2.82843 18.1667 2C18.1667 1.17157 17.4951 0.5 16.6667 0.5C12.2762 0.5 8.2255 1.99275 5.26151 4.80829C2.28563 7.63512 0.5 11.7065 0.5 16.6667C0.5 21.6269 2.28563 25.6982 5.26151 28.525C8.2255 31.3406 12.2762 32.8333 16.6667 32.8333C17.4951 32.8333 18.1667 32.1618 18.1667 31.3333C18.1667 30.5049 17.4951 29.8333 16.6667 29.8333C12.9538 29.8333 9.67117 28.5761 7.32766 26.35C4.99604 24.1351 3.5 20.8731 3.5 16.6667ZM13 15.2764C12.1716 15.2764 11.5 15.9479 11.5 16.7764C11.5 17.6048 12.1716 18.2764 13 18.2764H31.645C32.4734 18.2764 33.145 17.6048 33.145 16.7764C33.145 15.9479 32.4734 15.2764 31.645 15.2764H13Z"
      />
    </svg>
  );
};

export default Logoutbtn;
